import React from 'react';
import Relay from 'react-relay';

import isSold from 'depop/utils/isSold';

import { FormattedMessage } from 'react-intl';

import { YELLOW } from 'depop/styles/colors';
import { FAMILY_EXTENDED_BOLD } from 'depop/styles/typography';

import InvalidProductListItem from './InvalidProductListItem';

import ProductLink from 'depop/apps/shops/links/ProductLink';

import Picture from 'depop/components/images/Picture';

import { style, media, active, hover } from 'glamor';
import { formatProductPrice } from 'depop/utils/money';
import { trackProductCardClick } from 'depop/utils/tracking';
import VideoIndicator from 'depop/components/icons/VideoIndicator';


const OVERLAY_Z_INDEX = 50;
const SOLD_Z_INDEX = 70;
const VIDEO_Z_INDEX = 90;

const overlayStyle = {
  content: '""',
  display: 'block',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  left: 0,
  zIndex: OVERLAY_Z_INDEX,
  backgroundColor: 'rgba(0,0,0,0.3)'
};

const productLinkStyle = {
  position: 'relative',
  textDecoration: 'none',
  color: 'inherit',
};

const soldLabelStyle = {
  position: 'absolute',
  fontSize: 16,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, .2)',
  textTransform: 'uppercase',
  letterSpacing: '.05em',
  color: YELLOW,
  padding: '4px 15px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: FAMILY_EXTENDED_BOLD,
  zIndex: SOLD_Z_INDEX
};

const videoIndicatorStyle = {
  display: 'inline-block',
  position: 'absolute',
  top: '10px',
  right: '9px',
  zIndex: VIDEO_Z_INDEX
};

const priceLabelStyle = {
  display: 'none',
  margin: '4px 0 calc(4px - 0.5vw)',
  maxWidth: '100%',
  width: '12em',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  fontSize: 12,
  fontFamily: FAMILY_EXTENDED_BOLD,
  textOverflow: 'ellipsis',
};


class ProductListItem extends React.PureComponent {
  props: {
    product: Object,
    from: ?string,
    productListIndex: number,
    listName: string,
  };

  trackClick = () => {
    trackProductCardClick({
      id: this.props.product.publicId,
      index: this.props.productListIndex,
      listName: this.props.listName,
    });
  };

  render() {
    const { product, from, productListIndex } = this.props;

    if (!product.picture) {
      return <InvalidProductListItem />;
    }

    const hasVideo = !!product.videos && product.videos.length && !!product.videos[0].url;

    return (
      <ProductLink
        {...style(productLinkStyle)}
        product={product}
        onClick={this.trackClick}
        from={from}
        listIndex={productListIndex}>
        <div
          {...style({ position: 'relative', background: 'black' })}
          {...hover({
            '@media(min-width: 701px)': {
              '::after': overlayStyle
            }
          })}>
          <div {...active({ opacity: '0.8' })}>
            <Picture picture={product.picture} />
          </div>
          {
            isSold(product)
              ? <div {...style(soldLabelStyle)}>
                  <FormattedMessage
                    id="ProductListItem.Sold"
                    defaultMessage="Sold"
                  />
                </div>
              : null
            }
            {
              hasVideo
              ?
                <span {...style(videoIndicatorStyle)}><VideoIndicator /></span>
              : null
            }
        </div>
        <div
          {...style(priceLabelStyle)}
          {...media('(min-width: 701px)', { display: 'block' })}>
          {formatProductPrice(
            product.price.display,
            product.price.currencySymbol,
          )}
        </div>
      </ProductLink>
    );
  }
}

export default Relay.createContainer(ProductListItem, {
  fragments: {
    product: () => Relay.QL`
      fragment on Product {
        ${ProductLink.getFragment('product')}
        publicId
        slug
        saleStatus
        price {
          currencySymbol
          display
        }
        videos {
          url
        }
        picture {
          ${Picture.getFragment('picture')}
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/components/ProductList/ProductListItem.js